import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import AddCar from '@/pages/AddCar';
import EditCar from '@/pages/EditCar';
import ManageFields from '@/pages/ManageFields';
import Settings from '@/pages/Settings';
import AuthGuard from '@/components/AuthGuard';
import '@/App.css';

function App() {
  return (
    <div className="App dark">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <AuthGuard>
                <Dashboard />
              </AuthGuard>
            }
          />
          <Route
            path="/add-car"
            element={
              <AuthGuard>
                <AddCar />
              </AuthGuard>
            }
          />
          <Route
            path="/edit-car/:id"
            element={
              <AuthGuard>
                <EditCar />
              </AuthGuard>
            }
          />
          <Route
            path="/manage-fields"
            element={
              <AuthGuard>
                <ManageFields />
              </AuthGuard>
            }
          />
          <Route
            path="/settings"
            element={
              <AuthGuard>
                <Settings />
              </AuthGuard>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
